import { Component, Inject, Renderer2 } from '@angular/core';
import { context } from 'bookingbug-core-js';
import { AppConfig } from './app.config';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { DatastoreService } from './services/datastore.service';
import { AlertService } from './_alert';
import { IconSpriteService } from './services/icon-sprite.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 're3 HWRC Booking Service';
  loadIssue: boolean;

  constructor(
    private translate: TranslateService,
    private router: Router,
    private DataStore: DatastoreService,
    private alertService: AlertService,
    private iconSprite: IconSpriteService,
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {
    translate.setDefaultLang('en');

    this.DataStore.notify.subscribe((result) => {
      this.loadIssue = result;
      this.scrollToTop();
      this.alertService.clear();
      this.alertService.error(this.translate.instant('COMMON.LOAD_ISSUE'));
    });
  }

  ngOnInit() {
    this.iconSprite.inject();

    // BB Context storage
    context.apiUrl = AppConfig.settings.apiServer.api_url;
    context.apiVersion = AppConfig.settings.apiServer.version;
    try {
      const nr = window['newrelic'];
      this.DataStore.newRelic = nr;
    } catch (err) {
      console.log(err);
    }

    // Google Translate widget. The element.js loader calls back into
    // googleTranslateElementInit, which binds the picker to the
    // #google_translate_element div in app.component.html.
    const script = this.renderer2.createElement('script');
    script.type = 'text/javascript';
    script.src =
      'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    this.renderer2.appendChild(this.document.body, script);

    const fnScript = this.renderer2.createElement('script');
    fnScript.type = 'text/javascript';
    fnScript.text = `function googleTranslateElementInit() {
      new google.translate.TranslateElement(
          {pageLanguage: 'en'},
          'google_translate_element'
      );
    }`;
    this.renderer2.appendChild(this.document.body, fnScript);

    // storage event to modify localStorage
    //   window.addEventListener('storage', (event) => {
    //     if (event.storageArea == localStorage) {
    //          let token = localStorage.getItem('token_name');
    //          if(token == undefined) {
    //            // Perform logout
    //            //Navigate to homepage
    //             this.router.navigate(['/departments']);
    //          }
    //     }
    // });
    // }
  }

  scrollToTop() {
    const scrollToTop = window.setInterval(() => {
      const pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20);
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 10);
  }
}
